<template>
  <div class="listPage">
    <div class="topContainer">
      <!-- 筛选日期 -->
      <div class="dateDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-date-picker
              class="formInputClass"
              v-model="queryForm.startTime"
              type="datetime"
              placeholder="请选择开始时间"
             @change="()=>{queryForm.endTime =null}"
            >
            </el-date-picker>
            <span style="color: #fff;"> - </span>
            <el-date-picker
              class="formInputClass"
              placeholder="请选择结束时间"
              v-model="queryForm.endTime"
              type="datetime"
              :picker-options="endTimePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <el-button
          type="text"
          class="btnTxt"
          @click="query()"
        >
          <span style="color: #fff;">查询</span>
        </el-button>
      </div>

      <el-button
        type="text"
        class="btnTxt"
        @click="exportClick()"
      >
        <span style="color: #fff;">导出</span>
      </el-button>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="commonTable"
        tooltip-effect="light"
      >
        <!-- <el-table-column
          prop="id"
          label="id"
          min-width="20"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column> -->
        <el-table-column label="日志类别" align="center" min-width="40">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">运行日志</span>
            <span v-if="scope.row.type == 1">操作日志</span>
            <span v-if="scope.row.type == 2">告警日志</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="level"
          label="级别"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="内容"
          min-width="120"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="timestamp"
          label="日志时间"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
<!--        <el-table-column-->
<!--          prop="callerClass"-->
<!--          label="调用类名"-->
<!--          min-width="60"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--        ></el-table-column>-->
<!--        <el-table-column-->
<!--          prop="callerMethod"-->
<!--          label="调用方法"-->
<!--          min-width="40"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--        ></el-table-column>-->
<!--        <el-table-column-->
<!--          prop="callerLine"-->
<!--          label="代码行数"-->
<!--          min-width="40"-->
<!--          align="center"-->
<!--          :show-overflow-tooltip="true"-->
<!--        ></el-table-column>-->
        <el-table-column
          prop="userNo"
          label="操作人编号"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="updateAt"
          label="更新时间"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { getAllKey } from "@/assets/js/tree/tree.js";
import axios from "axios";

export default {
  name: "logManage",
  props: ["menuId"],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      title: "添加角色",
      total: 0, //总条数
      tableData: [],
      current: 1, //当前页数
      size: 6, //显示几条
      checkedNum: 0,
      totalTreeNum: 0,
      checkAll: false,
      form: {
        id: "",
        roleName: "",
        permission: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请填写角色名称~", trigger: "blur" },
        ],
      },
      /* 选项列表数据(树形结构的对象数组) */
      dataOfTree: [{}],
      // 该数组回显数据根据所对应的ID  进行默认勾选 (:default-checked-keys 这个) 和 (node-key="id") 这个两个并存
      defaultCheckKeys: [],
      defaultProps: {
        children: "children",
        label: "name", // 这里的名字要和你封装的数据中的节点的名字一样
      },

      queryForm: {
        startTime: "", // 开始时间
        endTime: "", // 结束时间
      },
      tableHeight: 500, // 表格高度
    };
  },
  computed: {
    endTimePickerOptions() {

          let curDate = this.$moment(this.queryForm.endTime).format("YYYY-MM-DD")
          if (this.queryForm.startTime) {
            //最小日期
            let minDate = this.$moment(this.queryForm.startTime).format("YYYY-MM-DD")
            //前推一天，防止当天日期无法选择
            let preTime = this.queryForm.startTime - 24 * 3600000
            // 如果选择的日期为最小日期，则设置为最小日期的时分秒
            let str = ""
            if (curDate == minDate) {
              str = this.$moment(this.queryForm.startTime).format("HH:mm:ss")
            } else {
              str = "00:00:00"
            }
            return {
              disabledDate: (time) => {
                return time.getTime() < preTime
              },
              selectableRange: str + " - 23:59:59",
            }
          } else {
            return {
              disabledDate: () => {
                return false
              },
            }
          }
    }
  },
  methods: {
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    getTableHeight() {
      let tableH = 305; // 除表格外其他区域高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = tableHeightDetil;
      }
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //获取选中和半选中状态下的数据
            let res = this.$refs.tree
              .getCheckedNodes()
              .concat(this.$refs.tree.getHalfCheckedNodes());

            if (0 === res.length) {
              let tips =
                "<i class='el-icon-warn-tip'></i>请给角色赋予对应权限";
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
              return false;
            } else {
              let permission = "";
              for (let i = 0, leng = res.length; i < leng; i++) {
                let item = res[i];
                permission += item.id;
                if (i !== leng - 1) {
                  permission += ",";
                }
              }
              this.form.permission = permission;
            }
            if (this.form.id) {
              //编辑
              this.update(this.form);
            } else {
              //新增
              this.save(this.form);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    // 查询
    query() {
      try {
        this.loading = true;
        let current = 1;
        let size = 6;
        let startTime = this.$moment(this.queryForm.startTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let endTime = this.$moment(this.queryForm.endTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      // console.log('查询',startTime, endTime);
        current = this.current;
        size = this.size;
        this.getRequest(
          `/uav-task-server/log/listPage?current=${current}&size=${size}&startTime=${startTime}&endTime=${endTime}`,
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            this.tableData = data.records;
            this.total = data.total;
          } else if (oData.code != 401) {}
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 导出
    exportClick() {
      try {
        let current = this.current;
        let size = this.size;
        let startTime = this.$moment(this.queryForm.startTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let endTime = this.$moment(this.queryForm.endTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        axios({
          method: "post",
          // url: `/uav-task-server/log/exportExcel?current=${current}&size=${size}&startTime=${startTime}&endTime=${endTime}`,
          url: `/uav-task-server/log/exportExcel?current=1&size=${this.total}&startTime=${startTime}&endTime=${endTime}`,
          responseType: "blob"
        }).then(res=>{
          const contentDisposition = res.headers['content-disposition'];
          let filename = contentDisposition.split('filename=')[1];
          if (filename) {
            filename = decodeURIComponent(filename.trim().replace(/"/g, ''));
            filename = filename.replace(/[\/\\:*?"<>|]/g, '_'); // 替换非法字符
          } else {
            filename = '日志信息.xlsx'; // 设置默认文件名
          }
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
          })
      } catch (error) {
        this.$message({
          message: "导出失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {},
        });
      }
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
  },
  mounted() {
    this.setGutterWidth();
    const now = new Date();
    const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    this.queryForm.startTime = oneWeekAgo;
    this.queryForm.endTime = now;
    this.query();
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    this.getTableHeight();
  },
  watch: {
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
.labelClass {
  display: flex;
  flex-direction: row;
}
.numClass {
  color: #0083fd;
}


.topContainer {
  display: flex;
  justify-content: end;
  height: 40px;
  //position: absolute;
  top: 15px;
  right: 0;
}
.dateDiv {
  display: flex;
}
.btnTxt {
  width: 62px;
  height: 32px;
  background: url(../../../assets/img/admin/btn_click.png) center no-repeat;
  background-size: 100% 100%;
  color: #DFF2FF;
  font-size: 16px;
  text-align: center;
  line-height: 10px;
  margin-top: 5px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/user/logManage.vue